import img1 from "./images/img1.jpg";
import img2 from "./images/img2.jpg";
import img3 from "./images/img3.jpg";
import img4 from "./images/img4.jpg";
import img5 from "./images/img5.jpg";
import logo1 from "./images/logo1.jpg";
import logo2 from "./images/logo2.jpg";
import logo3 from "./images/logo3.jpg";
import logo4 from "./images/logo4.jpg";
import logo5 from "./images/logo5.jpg";

import wPic from "./images/w-product1.jpg";
import { v4 as uuidv4 } from "uuid";

export const brands = [
  {
    id: uuidv4().toString(),
    brandImage: img1,
    brandLogo: logo1,
    offer: "60% Off + Buy one get one free",
  },
  {
    id: uuidv4().toString(),
    brandImage: img2,
    brandLogo: logo2,
    offer: "60% Off + Buy one get one free",
  },
  {
    id: uuidv4().toString(),
    brandImage: img3,
    brandLogo: logo3,
    offer: "60% Off + Buy one get one free",
  },
  {
    id: uuidv4().toString(),
    brandImage: img4,
    brandLogo: logo4,
    offer: "60% Off + Buy one get one free",
  },
  {
    id: uuidv4().toString(),
    brandImage: img5,
    brandLogo: logo5,
    offer: "60% Off + Buy one get one free",
  },
];

export const products = [
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: true,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Slim fit shirt",
    category: "men",
    picture: wPic,
    isFeatured: true,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: true,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: true,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Slim fit shirt",
    category: "men",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "women",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "kids",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "kids",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "kids",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "kids",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "kids",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "kids",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "kids",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "kids",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "kids",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "kids",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "other",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "other",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "other",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "other",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "other",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "other",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "other",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "men",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "men",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "men",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "men",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "men",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "others",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "others",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "others",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "others",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "others",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "others",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "others",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "others",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
  {
    id: uuidv4().toString(),
    title: "Levi's Shirt",
    sizes: ["S", "M", "L", "XL", "XXL"],
    description: `
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. 
    The passage is attributed to an unknown typesetter in the 15th century who is
     thought to have scrambled parts of Cicero's De Finibus Bonorum et Malorum for use in a type specimen book.
    `,
    type: "Reguler fit shirt",
    category: "others",
    picture: wPic,
    isFeatured: false,
    originalPrice: 2800,
    discount: 50,
    quantity: 5,
  },
];
